import $http from '@/libs/axios'

class WizardAPIs {
  static async update(wizard: string) {
    return (await $http.put('/wizard/update', { wizard })).data
  }
}

export default WizardAPIs
